module.exports = __webpack_public_path__ + "static/img/iot接入服务.a5580cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/product-article/iot接入服务.png
// module id = 652
// module chunks = 1